import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl ='produkkredit';
export default{
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(baseurl,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'partnumber', 'idStore', 'nmcategory', 'headcategory', 'purcOrderNo', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'vendorinfo', 'gcifNo', 'outstand', 'barangbekas', 'barangbarter'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        }) 
    },
    detail(key) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`${baseurl}/detail/${key}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}